import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import { DateDifference } from "../../utils/DateDIfference";
import Typography from "../Typography/Typography";
import aadi from "../../assets/images/aadi.svg";
import bronze from "../../assets/images/bronze.svg";
import silver from "../../assets/images/silver.svg";
// import { Silver } from "../../assets/Icon/Silver";
import gold from "../../assets/images/gold.svg";
import vip from "../../assets/images/vip.svg";
import { MiladiToShamsi } from "../../utils/Miladi_To_Shamsi";
export const AdvancedSearchItem = ({ data, advanced }) => {
  return (
    <Fragment>
      {data?.pages?.map((page) =>
        page?.data?.sales_opportunities.map((item, index) => {
          const FirstName = item.FirstName === null ? " " : item.FirstName;
          const LastName = item.LastName === null ? " " : item.LastName;
          return (
            <div
              className={`${
                advanced
                  ? "col-lg-4 col-md-6 col-sm-12 col-12 mb-3"
                  : "col-lg-3 col-md-6 col-sm-12 col-12 mb-3"
              }`}
              key={index}
            >
              <Link
                to={`/dashboard/crm/customer-file/${item.IdS0alesOpportunities}`}
                target="_blank"
              >
                <div className="file">
                  <div className="d-flex">
                    <div className="profile p-2 w-50">
                      <Typography size="14px" color="red">
                        {FirstName + " " + LastName}
                      </Typography>
                      <Typography size="14px">0{item.Phone}</Typography>
                    </div>
                    <div className="major-details w-50 p-2">
                      <Typography
                        size="14px"
                        primary={
                          item.RankingCustomer === "معمولی"
                            ? "#40afa1"
                            : item.RankingCustomer === "برنزی"
                            ? "#c77b30"
                            : item.RankingCustomer === "نقره ای"
                            ? "#c0c0c0"
                            : item.RankingCustomer === "طلایی"
                            ? "#e6c200"
                            : item.RankingCustomer === "vip"
                            ? "#6768ab"
                            : "#000"
                        }
                      >
                        {item.RankingCustomer}{" "}
                        <img
                          src={
                            item.RankingCustomer === "معمولی"
                              ? aadi
                              : item.RankingCustomer === "برنزی"
                              ? bronze
                              : item.RankingCustomer === "نقره ای"
                              ? silver
                              : item.RankingCustomer === "طلایی"
                              ? gold
                              : item.RankingCustomer === "vip"
                              ? vip
                              : null
                          }
                          alt=""
                          style={{ width: "20px" }}
                        />
                      </Typography>
                      <Typography
                        size="14px"
                        primary={
                          item.KindCustomer === "سرنخ"
                            ? "#ff00fb"
                            : item.KindCustomer === "مشتری"
                            ? "#fe6701"
                            : "#000"
                        }
                      >
                        {item.KindCustomer}
                      </Typography>
                      <Typography size="14px">
                        تاریخ ثبت: {MiladiToShamsi(item.created_at)}{" "}
                      </Typography>
                    </div>
                  </div>
                  <div className="tiny-details p-2">
                    <Typography size="12px">
                      نحوه آشنایی: {item.methodOfIntroduction}
                    </Typography>
                    <Typography size="12px">
                      نوع فروش : {item.KindSeller}
                    </Typography>
                    <Typography size="12px">شهر:{item.NameCities}</Typography>
                    <Typography size="12px">
                      بازاریاب:{" "}
                      {item.IdMarketer !== 38
                        ? page?.data?.Marketersales_opportunities.map(
                            (marketer, index) => (
                              <Fragment key={index}>
                                {marketer.IdS0alesOpportunities ===
                                  item.IdS0alesOpportunities &&
                                item.IdMarketer !== 38
                                  ? marketer.FirstName + " " + marketer.LastName
                                  : ""}
                              </Fragment>
                            )
                          )
                        : "بدون بازاریاب"}
                    </Typography>
                    <Typography size="12px">
                      مسئول:{" "}
                      {page?.data?.Responsiblesales_opportunities?.map(
                        (responsible, index) => (
                          <Fragment key={index}>
                            {responsible.IdS0alesOpportunities ===
                            item.IdS0alesOpportunities
                              ? responsible.FirstName +
                                " " +
                                responsible.LastName
                              : ""}
                          </Fragment>
                        )
                      )}
                    </Typography>
                  </div>
                </div>
              </Link>
            </div>
          );
        })
      )}
      {/*  */}
    </Fragment>
  );
};
